import { useDeviceType } from '../../../hooks/useDeviceType';
import { MetaBallContainer } from '../../MetaBallContainer';
import React from 'react';
import type { IContainer } from './Container';

export const WrapperComponent = ({ children, ratingMsg }: IContainer) => {
  const { isMobile } = useDeviceType();
  const upperRight = ratingMsg?.upperRightCorner?.url;
  const lowerLeft = ratingMsg?.lowerLeftCorner?.url;
  return isMobile ? (
    children
  ) : (
    <MetaBallContainer topRightImage={upperRight} bottomLeftImage={lowerLeft}>
      {children}
    </MetaBallContainer>
  );
};
